
import { supabaseWorker } from '@/integrations/supabase/workerClient';
import { MessageCache } from './messageCache';

/**
 * Core message operations for reading and updating message states
 */
export class MessageCore {
  /**
   * Marks a specific message as read
   */
  static async markMessageAsRead(messageId: string): Promise<void> {
    const { error } = await supabaseWorker
      .from('messages')
      .update({ is_read: true })
      .eq('id', messageId);

    if (error) throw error;

    // Invalidate cache
    MessageCache.clearCache();
  }

  /**
   * Marks all messages in a conversation as read
   */
  static async markConversationAsRead(conversationId: string): Promise<void> {
    const { error } = await supabaseWorker
      .from('messages')
      .update({ is_read: true })
      .eq('conversation_id', conversationId)
      .eq('direction', 'incoming')
      .eq('is_read', false);

    if (error) throw error;

    // Invalidate cache
    MessageCache.clearCache();
  }
}
